import { ElementNode } from ".";
import { ElementType } from "../enums";
import { TemplateNodeVisitor } from "./ops";

export class LabelNode extends ElementNode {
    public constructor() {
        super();
        this.elementType = ElementType.VariableText;
    }

    public accept(visitor: TemplateNodeVisitor) {
        visitor.visitLabelNode(this);
    }
}

export class ImageNode extends ElementNode {
    public constructor() {
        super();
        this.elementType = ElementType.Image;
    }

    public accept(visitor: TemplateNodeVisitor) {
        visitor.visitImageNode(this);
    }
}

export class InvalidNode extends ElementNode {
    public constructor() {
        super();
        this.elementType = ElementType.Invalid;
    }

    public accept(visitor: TemplateNodeVisitor) {
        visitor.visitInvalidNode(this);
    }
}
